<template>
  <div class="mobile_header">
    <div class="header_box" :style="{ background: isDark ? '#24272a' : '#f0f1fa' }">
      <img @click="goIndex('/en')" v-if="!isDark"
        src="https://download.hecoos.com/enlightv/2025-19/ca5b4bb87eccd0b1d213998c906f079a.png" alt="" />
      <img v-else @click="goIndex('/en')"
        src="https://download.hecoos.com/enlightv/2025-19/38d3378c48cab69138c522b5e915b50a.png" alt="" />
      <div style="display: flex; align-items: center; justify-content: center">
        <div @click="changeLanguage" class="langChange">{{ languageText }}</div>
        <div @click="showMenu" class="header_box_right">
          <span>··</span>
        </div>
      </div>
    </div>

    <div class="menu" :class="{ show: isShow }">
      <span class="menu_close" @click="hideMenu">&times;</span>
      <div v-for="item in path" :key="item.id">
        <div class="menu_item_f" @click="toggleSubMenu(item)">
          <router-link :to="item.url ? item.url : $route.path" class="menu_item"
            :class="{ currently: item.url === $route.path }"
            :style="{ color: item.url === $route.path ? '#2a82e4' : '#fff' }">{{ item.name }}</router-link>
          <span class="arrow iconfont icon-xiangxiajiantou" :class="{ currently: item.url === $route.path }"
            v-if="item.item && item.item.length > 0"></span>
        </div>


        <div v-show="item.showSubMenu" v-for="subItem in item.item" :key="subItem.id">
          <div class="sub-menu" @click="toggleSubMenu1(subItem)">
            <router-link :to="subItem.url ? subItem.url : $route.path" class="SonMenu_item"
              :class="{ currently: subItem.url === $route.path }"
              :style="{ color: subItem.url === $route.path ? '#2a82e4' : '#fff' }">{{ subItem.name }}</router-link>

            <span class="arrow iconfont icon-xiangxiajiantou" :class="{ currently: subItem.url === $route.path }"
              v-if="subItem.item && subItem.item.length > 0"></span>
          </div>

          <div v-show="subItem.showSubMenu" class="subSubItem_name" v-for="subSubItem in subItem.item">
            <router-link :to="subSubItem.url ? subSubItem.url : $route.path"
              :style="{ color: subSubItem.url === $route.path ? '#2a82e4' : '#fff' }">{{ subSubItem.name
              }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      path: [
        {
          id: 1,
          name: "Home",
          url: "/en",
          showSubMenu: false,
        },
        {
          id: 2,
          name: "Solutions",
          item: [
            {
              id: 21,
              name: "projection",
              url: "/en/projection",
            },
            {
              id: 22,
              name: "lightingDesign",
              url: "/en/lightingDesign",
            },
            {
              id: 23,
              name: "xR/VP",
              url: "/en/virtualProduction",
            },
            {
              id: 24,
              name: "renderInteraction",
              url: "/en/renderInteraction",
            },
          ],
          showSubMenu: false,
        },
        {
          id: 3,
          name: "Products",
          item: [
            {
              id: 31,
              name: "hecoos Studio",
              url: "/en/studio",
            },
            {
              id: 32,
              name: "hecoos Lighting",
              url: "/en/hecoosLighting",
            },
            {
              id: 33,
              name: "hecoos Server",
              url: "/en/mediaServer",
              // item: [
              //   {
              //     id: '331',
              //     name: "server-D",
              //     url: "/en/mediaServer?section=0",
              //   },
              //   {
              //     id: '342',
              //     name: "server-C",
              //     url: "/en/mediaServer?section=1",
              //   },
              //   {
              //     id: '343',
              //     name: "server-R",
              //     url: "/en/mediaServer?section=2",
              //   },
              // ]
            },
            {
              id: 34,
              name: "Other Products",
              item: [
                {
                  id: 341,
                  name: "Mirror",
                  url: "/en/projectorbit",
                },
              ],
              showSubMenu: false,
            },
          ],
          showSubMenu: false,
        },
        {
          id: 4,
          name: "Training",
          showSubMenu: false,
          item: [
            {
              id: 41,
              name: "hecoos Video Tutorial",
              url: "/en/video_tutorial",
            },
            {
              id: 42,
              name: "Joint Specialty Development",
              url: "/en/construction",
            },
            // {
            //   id: 43,
            //   name: "艺书学习平台",
            //   url: "https://www.artbook.top",
            // }
          ]
        },
        {
          id: 5,
          name: "Subscription",
          url: "/en/SoftwareSubscriptions",
          showSubMenu: false,
        },
        {
          id: 6,
          name: "Showcase",
          url: "/en/casepresentation",
          showSubMenu: false,
        },
        {
          id: 7,
          name: "About us",
          url: "/en/CaseDemonstration",
          showSubMenu: false,
        },
        {
          id: 8,
          name: "Personal Center",
          url: "/en/personalCenter",
          showSubMenu: false,
        },
      ],
    };
  },
  props: {
    isDark: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    goIndex(path) {
      this.$router.push(path);
    },
    toggleSubMenu(item) {

      if (item.item && item.item.length > 0) {
        // 先关闭所有子菜单
        this.path.forEach((p) => {
          if (p !== item) {
            p.showSubMenu = false;
          }
        });
        item.showSubMenu = !item.showSubMenu;
      }
    },
    toggleSubMenu1(item) {
      item.showSubMenu = !item.showSubMenu;
    },
    // changeLanguage() {
    //   const currentRoute = this.$route.path;
    //   const targetPrefix = this.$route.meta.language === "ch" ? "/en" : "";
    //   let targetRoute;
    //   if (currentRoute.startsWith("") || currentRoute.startsWith("/en")) {
    //     const regex = new RegExp(`^/${currentRoute.split("/")[1]}`);
    //     targetRoute = currentRoute.replace(regex, targetPrefix);
    //   } else {
    //     targetRoute = targetPrefix + "/home";
    //   }
    //   if (targetRoute !== currentRoute) {
    //     this.$router.push(targetRoute).then(() => {
    //       // 路由跳转成功后，强制更新组件，确保语言文本正确显示
    //       this.$forceUpdate();
    //     });
    //   }
    // },
    changeLanguage() {
      const currentRoute = this.$route.path;
      const isEnglish = this.$route.meta.language === "en"; // 判断当前是否是英文

      let targetRoute;

      if (isEnglish) {
        // 当前是英文，切换到中文（去掉/en前缀）
        if (currentRoute.startsWith("/en")) {
          targetRoute = currentRoute.replace(/^\/en/, '');
          // 处理根路径情况
          if (targetRoute === '') targetRoute = '/';
        } else {
          targetRoute = '/';
        }
      } else {
        // 当前是中文，切换到英文（添加/en前缀）
        if (currentRoute === '/') {
          targetRoute = '/en';
        } else {
          targetRoute = '/en' + currentRoute;
        }
      }

      if (targetRoute !== currentRoute) {
        this.$router.push(targetRoute).then(() => {
          this.$forceUpdate();
        });
      }
    },
    showMenu() {
      this.isShow = true;
      document.body.style.overflow = 'hidden';
    },
    hideMenu() {
      this.isShow = false;
      document.body.style.overflow = ''
    },
    handleOutsideClick(event) {
      const menu = this.$el.querySelector(".menu");
      const headerBoxRight = this.$el.querySelector(".header_box_right");
      if (
        menu &&
        !menu.contains(event.target) &&
        !headerBoxRight.contains(event.target)
      ) {
        this.isShow = false;
      }
    },
  },
  computed: {
    languageText() {
      return this.$route.meta.language === "ch" ? "EN" : "CN";
    },
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick.bind(this));
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick.bind(this));
    document.body.style.overflow = ''
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mobile_xty.scss";

@font-face {
  font-family: "iconfont";
  /* Project id 4847554 */
  src: url("//at.alicdn.com/t/c/font_4847554_50o1jolhtim.woff2?t=1741167400416") format("woff2"),
    url("//at.alicdn.com/t/c/font_4847554_50o1jolhtim.woff?t=1741167400416") format("woff"),
    url("//at.alicdn.com/t/c/font_4847554_50o1jolhtim.ttf?t=1741167400416") format("truetype");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-xiangxiajiantou:before {
  content: "\e651";
}

.isDark {
  background-color: #f0f1fa;
}

.menu {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh;
  background-color: #161617;
  text-align: right;
  z-index: 333;
  padding: 20px;
  opacity: 0;
  transform: translateY(-100%);
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: none;
  /* 隐藏时禁用点击事件 */

  .menu_close {
    color: #fff;
    font-size: 18px;
    margin-right: 12px;
  }

  .menu_item_f {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    color: #fff;

    .menu_item {
      width: 100%;
      font-size: 18px;
      color: #fff;
      display: block;
      text-decoration: none;
      text-align: left;
      padding: 10px 0;
    }
  }

  .sub-menu {
    font-size: 14px;
    text-align: left;
    padding: 0 24px;
    margin: 10px 0;
    display: flex;
    justify-content: space-between;

    .arrow {
      color: #fff;
    }

    a {
      text-decoration: none;
    }
  }

  .subSubItem_name {
    text-align: left;
    padding: 0 24px 5px;
    color: #fff;

    a {
      color: #fff;
    }
  }
}

.show {
  opacity: 1;
  transform: translateX(0);
  pointer-events: auto;
  /* 显示时启用点击事件 */
}

.currently {
  color: #2a82e4;
}

@media screen and (min-width: 768px){
  .isDark {
  background-color: #f0f1fa;
}

.menu {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh;
  background-color: #161617;
  text-align: right;
  z-index: 333;
  padding: 20px;
  opacity: 0;
  transform: translateY(-100%);
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: none;
  /* 隐藏时禁用点击事件 */

  .menu_close {
    color: #fff;
    font-size: 30px;
    margin-right: 12px;
  }

  .menu_item_f {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    color: #fff;

    .menu_item {
      width: 100%;
      font-size: 30px;
      color: #fff;
      display: block;
      text-decoration: none;
      text-align: left;
      padding: 10px 0;
    }
  }

  .sub-menu {
    font-size: 20px;
    text-align: left;
    padding: 0 24px;
    margin: 10px 0;
    display: flex;
    justify-content: space-between;

    .arrow {
      color: #fff;
    }

    a {
      text-decoration: none;
    }
  }

  .subSubItem_name {
    text-align: left;
    padding: 0 24px 5px;
    color: #fff;

    a {
      color: #fff;
      font-size: 18px;
    }
  }
}

.show {
  opacity: 1;
  transform: translateX(0);
  pointer-events: auto;
  /* 显示时启用点击事件 */
}

.currently {
  color: #2a82e4;
}
}
</style>
